import { useReportContext } from "@/context/ReportContext";
import type { SxProps } from "@/theme/index";
import { ReportActionButton } from "../ReportActionButton/ReportActionButton";
import { useSaveAction } from "./useSaveAction";

export interface SaveActionProps {
  sx?: SxProps;
  reportPermaLink?: string;
  onReportCard?: boolean;
  disableCollapse?: boolean;
}

export const SaveAction: React.FC<SaveActionProps> = ({
  sx,
  reportPermaLink,
  onReportCard,
  disableCollapse,
}) => {
  const { permalink: contextPermalink } = useReportContext();
  const permalink = reportPermaLink || contextPermalink;
  const { foundReportInSavedReports, handleAddRemoveAction, isLoading } =
    useSaveAction({
      reportPermaLink: permalink,
    });
  const active = !!foundReportInSavedReports;
  const handleClickAddRemoveAction = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.stopPropagation();
    handleAddRemoveAction();
  };
  return (
    <ReportActionButton
      iconName={active ? "Favorite" : "FavoriteBorder"}
      collapseText={active ? "Saved" : "Save"}
      onClick={handleClickAddRemoveAction}
      active={active}
      sx={sx}
      onReportCard={onReportCard}
      disableCollapse={disableCollapse}
      isLoading={isLoading}
    />
  );
};
